import { cilArrowLeft } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import {CFooter,CButton, CCard, CCardBody, CCardHeader, CCol, CForm, CFormInput, CFormLabel, CFormSelect, CFormTextarea, CRow, CToast, CToastBody, CToastClose } from '@coreui/react'
import axios from 'axios'
import React,{useState, useEffect} from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { endPoints } from '../../../../../Constants'
import { getAccessToken, writeDocumentTitle } from '../../../../../Helpers'

const Add = (props) => {
      const [inputValues, setInputValue] = useState({
            customer_id:'',
            name:'',
            status:'1'
      });
      const [validation, setValidation] = useState({
            customer_id:'',
            name:'',
            status:'1'
      });
      const [customersList, setCustomersList] = useState([]);
      const [showAlert, setShowAlert] = useState(false);
      const [showMessage, setShowMessage] = useState('');
      const [color, setColor] = useState('');
      const navigate = useNavigate();
      
      const handleChange = (e) => {
          const { name, value } = e.target;
          setInputValue({ ...inputValues, [name]: value });
      }
      useEffect(()=>{
            writeDocumentTitle(props.title);
            /*---------------- get access token --------------*/
            const accessToken = getAccessToken();
            if(!accessToken) {
                localStorage.removeItem('isAdminLoggedIn');
                navigate(`${process.env.PUBLIC_URL}/`);
            }
            const config = {
                headers: { Authorization: `Bearer ${accessToken}` }
            };
          /*---------------- get access token --------------*/
          
          axios.get(`${endPoints}customerList`,config)
          .then((response)=>{
              if(response.data.aLists) { 
                  setCustomersList(response.data.aLists);
              }
          })
          .catch((error)=>{
              if(error.response && error.response.status === 401) {
                localStorage.removeItem('isAdminLoggedIn');
                navigate(`${process.env.PUBLIC_URL}/`);
              }
          })
      },[]);
      
    /*------------- form validation ---------------*/
            const checkValidation = () => {
              let errors = {};
              if(!inputValues.customer_id.trim()) {
                errors.customer_id = "Customer is required";
              } 
              if(!inputValues.name.trim()) {
                errors.name = "Field name is required";
              } 
              return errors;
          };
    
  /*------------- form validation ---------------*/
      
  /*------------ handle form submit ----------*/
        const handleSubmit = async (e) => {
          e.preventDefault();
          let isErrors = await checkValidation(inputValues);
          setValidation(isErrors);
          if(Object.keys(isErrors).length === 0) {
                /*---------------- get access token --------------*/
                    const accessToken = getAccessToken();
                    if(!accessToken) {
                        localStorage.removeItem('isAdminLoggedIn');
                        navigate(`${process.env.PUBLIC_URL}/`);
                    }
                    const config = {
                        headers: { Authorization: `Bearer ${accessToken}` }
                    };
               /*---------------- get access token --------------*/
                  setShowAlert(false);
                  setColor('');
                  axios.post(`${endPoints}add-field`,inputValues,config)
                  .then((response)=>{
                    if(response.data.status === true) {
                        setShowMessage(response.data.message);
                        setShowAlert(true);
                        setColor('success');
                        setInputValue({
                            customer_id: '',
                            name:'',
                            status:'1'
                        });
                        // setTimeout(()=>{
                        //   navigate(`${process.env.PUBLIC_URL}/admin/users`);
                        // },1500);
                    } else {
                        setShowMessage(response.data.message);
                        setShowAlert(true);
                        setColor('failure');
                    }           
                  })
                  .catch(function (error) {
                      if(error.response && error.response.status === 401) {
                          localStorage.removeItem('isAdminLoggedIn');
                          navigate(`${process.env.PUBLIC_URL}/`);
                      }
                  }); 
    
          } 
          
      }
  /*------------ handle form submit ----------*/
  return (
     <>
       <CRow className="align-items-center mb-2">
          <CCol xs={3}></CCol>
             <CCol xs={6}>
                <CToast autohide={true} delay={5000} visible={showAlert} color={`${color && color==='failure' ? 'danger' : 'success' }`} animation={true} className="text-white align-items-center">
                              <div className="d-flex">
                                <CToastBody>{showMessage}</CToastBody>
                                <CToastClose className="me-2 m-auto" />
                              </div>
                  </CToast>
             </CCol>
          <CCol xs={3}></CCol>
       </CRow>
       <CRow>
        
          <CCol xs={12}>
            <CCard className="mb-4">
              <CCardHeader>
               <CRow className="align-items-center">
                  <CCol xs={8} ><h5 className="cardHeading">New Field</h5></CCol>
                  <CCol xs={4} className="text-end">
                      <NavLink to={`${process.env.PUBLIC_URL}/admin/master/fields`} className="linkText"><CIcon icon={cilArrowLeft} className="me-2" />Back</NavLink>
                  </CCol>
              </CRow>
                
              </CCardHeader>
              <CCardBody>
               
                  <CForm onSubmit={handleSubmit}>
                   <CRow>
                   <CCol xs={12} md={6} xl={6}>
                            <div className="mb-3">
                              <CFormLabel htmlFor="customer_id">Customer<span className="formError">*</span></CFormLabel>
                              <CFormSelect aria-label="Default select example" 
                                name="customer_id"
                                id="customer_id"
                                onChange={(e) => handleChange(e)} 
                                value={inputValues.customer_id}>
                                  <option value="">Select Customer</option>
                                  {
                                    customersList && customersList.length > 0 ? customersList.map((item,index)=><option key={item.id} value={item.id}>{item.name}</option>) : null
                                  }
                                  
                              </CFormSelect>
                              <p className="formError">{validation.customer_id ? validation.customer_id :  ''}</p>
                            </div>
                      </CCol>
                      <CCol xs={12} md={6} xl={6}>
                            <div className="mb-3">
                              <CFormLabel htmlFor="name">Field<span className="formError">*</span></CFormLabel>
                              <CFormInput
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Field"
                                onChange={(e) => handleChange(e)} 
                                value={inputValues.name}
                              />
                              <p className="formError">{validation.name ? validation.name :  ''}</p>
                            </div>
                        </CCol>
                        
                        <CCol xs={12} md={6} xl={6}>
                            <div className="mb-3">
                              <CFormLabel htmlFor="status">Status<span className="formError">*</span></CFormLabel>
                              <CFormSelect aria-label="Default select example" name="status" id="status" onChange={(e) => handleChange(e)}>
                                  <option value="1">Active</option>
                                  <option value="0">Inactive</option>
                              </CFormSelect>
                            </div>
                        </CCol>
                    </CRow>
                    
                    <CFooter className='cardFooter'>
                         <CButton type="submit" color="success">Submit</CButton>
                    </CFooter>
                  </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
     </>
   )
}

export default Add
